import styled from "styled-components";

export const HeaderContainer = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
padding: 1rem;
margin: 2rem 0;
`

export const Title = styled.p`
font-family: Poppins;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  color: #45464e;
`

export const CardContainer  =styled.div`
display: flex;
// justify-content: center;
align-items: center;
// gap: 4rem;
padding: 1rem;
flex-wrap: wrap;
justify-content: flex-start;
  gap: 1rem;


`